import gql from 'graphql-tag';

export const CHECK_TELEGRAM_HEALTH = gql`
    query {
        checkTelegramHealth
    }
`;